// GENERATED CODE - DO NOT MODIFY BY HAND

import * as m from '@april9au/stack9-sdk';
import { z } from 'zod';

export const SubscaleOptionSet = [
  'Depression',
  'Anxiety',
  'Stress',
  'Physical Health',
  'Other',
] as const;
export const SubscaleOptionType = z.enum(SubscaleOptionSet);
export type SubscaleOptionType = z.infer<typeof SubscaleOptionType>;

export const HealthQuestion = z.object({
  health_screen_id: m.ZSingleDropDown,
  question_id: m.ZTextField,
  question_text: m.ZTextField,
  response: m.ZTextField.optional().nullable(),
  score: m.ZNumericField.optional().nullable(),
  subscale: SubscaleOptionType.optional().nullable(),
  question_order: m.ZNumericField.optional().nullable(),
});
export type HealthQuestion = z.infer<typeof HealthQuestion>;

export const DBHealthQuestion = m.ZEntityInterface.merge(HealthQuestion);
export type DBHealthQuestion = z.infer<typeof DBHealthQuestion>;
